<h2 mat-dialog-title>Información</h2>

<mat-dialog-content>
  <p>{{ data.mensaje }}</p>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" mat-dialog-close>Aceptar</button>
</mat-dialog-actions>